/* =========================================================================
   Stack — direct-to-checkout add to cart (bundle-safe)
   -------------------------------------------------------------------------
   1) DIRECT CHECKOUT: the Stack add-to-cart button and sticky bar add the
      product and go straight to /checkout (no cart drawer flash of
      "Your cart is empty").

   2) BUNDLE-SAFE ADD (Sep 21): each bundle tier stamps a __stack_bundle
      discount tag on the line (e.g. "p:10@2:Serenely Bundle Saving"). Tags
      differ per tier, so Shopify never merges adds across tiers. Adding a
      tier now REPLACES the product's existing line instead of stacking a
      second, differently-tagged line on top.

   3) CART EDITS (Sep 21): the theme's cart drawer / cart page +/- buttons
      change a line's quantity but never its discount tag — and the Stack
      discount Function only pays a tag out when the line holds that tier's
      quantity. So "1 Massager" bumped to 3 in the drawer stayed full price.
      After ANY cart change we now reconcile: each bundle product is merged
      into one line and re-tagged with the tier its new total earns (exact
      tier match first, else the largest tier it fully covers).

   Tier data (quantity -> discount tag) is read from the product page's
   <stack-bundle> block and remembered in localStorage, so reconciling also
   works from pages without the bundle block (e.g. the drawer on any page).

   Checkout clicks wait for any pending reconcile, so the discount is always
   correct by the time Shopify builds the checkout.

   Debug: set window.StackDebug = true in the console.
   ========================================================================= */
(function () {
  'use strict';

  if (window.__StackDirectCheckout) return;
  window.__StackDirectCheckout = true;

  var FORM_SELECTOR = '.stack-atc__form, .stack-sticky__form';
  var STORE_KEY = 'stack:bundle-tiers:v1';
  var CART_MUTATION = /\/cart\/(add|change|update|clear)(\.js)?\/?$/;

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }
  function log() {
    if (window.StackDebug && window.console) console.log.apply(console, ['[Stack bundle-safe]'].concat([].slice.call(arguments)));
  }
  function logErr() {
    if (window.console) console.error.apply(console, ['[Stack bundle-safe]'].concat([].slice.call(arguments)));
  }

  /* ---------------------------------------------------------------------
     Network — our own calls use the ORIGINAL fetch so they are never
     mistaken for a theme cart edit (which would re-trigger reconciling).
     --------------------------------------------------------------------- */
  var nativeFetch = window.fetch;

  function jsonOrThrow(res) {
    if (!res.ok) {
      return res.json().then(function (e) { throw e; }, function () { throw new Error('HTTP ' + res.status); });
    }
    return res.json();
  }
  function getCart() {
    return nativeFetch.call(window, root() + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(jsonOrThrow);
  }
  function postJSON(path, body) {
    return nativeFetch.call(window, root() + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(jsonOrThrow);
  }
  function addItems(items) { return postJSON('cart/add.js', { items: items }); }
  function changeLine(body) { return postJSON('cart/change.js', body); }

  /* ---------------------------------------------------------------------
     Tier map: { "<variantId>": { "<qty>": "<__stack_bundle value>" } }
     The value format mirrors stack.js tierDeal(): code + ':' + deal name.
     --------------------------------------------------------------------- */
  function loadTiers() {
    try { return JSON.parse(window.localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function saveTiers(map) {
    try { window.localStorage.setItem(STORE_KEY, JSON.stringify(map)); } catch (e) { /* private mode etc. */ }
  }
  var TIERS = loadTiers();

  function captureTiers() {
    var products = document.querySelectorAll('stack-product');
    var changed = false;
    for (var i = 0; i < products.length; i++) {
      var p = products[i];
      var bundle = p.querySelector('stack-bundle');
      if (!bundle) continue;
      var name = bundle.getAttribute('data-deal-name') || '';
      var map = {};
      var tiers = bundle.querySelectorAll('[data-tier]');
      for (var t = 0; t < tiers.length; t++) {
        var q = parseInt(tiers[t].getAttribute('data-quantity'), 10) || 0;
        if (q < 1) continue;
        var code = tiers[t].getAttribute('data-deal') || '';
        map[q] = code ? (name ? code + ':' + name : code) : '';
      }
      if (!Object.keys(map).length) continue;

      var ids = [];
      var script = p.querySelector('script[data-stack-product-data]');
      if (script) {
        try {
          var data = JSON.parse(script.textContent);
          (data.variants || []).forEach(function (v) { if (v && v.id != null) ids.push(String(v.id)); });
        } catch (e) { /* ignore */ }
      }
      var idInput = p.querySelector('.stack-atc__form input[name="id"]');
      if (idInput && idInput.value) ids.push(String(idInput.value));

      ids.forEach(function (id) { TIERS[id] = map; changed = true; });
    }
    if (changed) { saveTiers(TIERS); log('captured bundle tiers', TIERS); }
  }

  // Tag for `total` units: the exact tier if one exists (may be '' = no
  // discount), otherwise the largest discounted tier the total fully covers.
  function dealFor(map, total) {
    if (!map) return '';
    if (Object.prototype.hasOwnProperty.call(map, String(total))) return map[String(total)] || '';
    var best = '', bestQ = 0;
    for (var k in map) {
      if (!Object.prototype.hasOwnProperty.call(map, k)) continue;
      var q = parseInt(k, 10);
      if (map[k] && q <= total && q > bestQ) { bestQ = q; best = map[k]; }
    }
    return best;
  }

  // The "@<qty>" guard inside a tag (Infinity when absent → never pays out).
  function guardOf(tag) {
    var m = /@(\d+)/.exec(tag || '');
    return m ? parseInt(m[1], 10) : Infinity;
  }

  function isUpsellLine(line) {
    return !!(line.properties && line.properties.__stack_upsell);
  }

  /* Make the cart hold exactly ONE line of `variantId` with `qty` units and
     discount tag `deal`. Extra lines of that variant are removed FIRST (by
     key) so re-tagging the kept line can never collide/merge with them.
     Resolves true if anything changed. */
  function setVariantLine(cart, variantId, qty, deal) {
    var lines = ((cart && cart.items) || []).filter(function (l) {
      return l.variant_id === variantId && !isUpsellLine(l);
    });

    if (!lines.length) {
      if (qty < 1) return Promise.resolve(false);
      var item = { id: variantId, quantity: qty };
      if (deal) item.properties = { __stack_bundle: deal };
      return addItems([item]).then(function () { return true; });
    }

    var keep = lines[0];
    var extras = lines.slice(1);
    var cur = (keep.properties && keep.properties.__stack_bundle) || '';
    // With no deal due, a stale tag whose guard exceeds the quantity can't pay
    // out, so it's harmless and left alone.
    var tagOk = cur === deal || (!deal && (!cur || guardOf(cur) > qty));

    if (!extras.length && keep.quantity === qty && tagOk) return Promise.resolve(false);

    var chain = Promise.resolve();
    extras.forEach(function (l) {
      chain = chain.then(function () { return changeLine({ id: l.key, quantity: 0 }); });
    });
    chain = chain.then(function () {
      var body = { id: keep.key, quantity: qty };
      if (!tagOk) {
        // Keep any other line properties; only swap the bundle tag.
        var props = {};
        var old = keep.properties || {};
        for (var k in old) { if (Object.prototype.hasOwnProperty.call(old, k)) props[k] = old[k]; }
        if (deal) props.__stack_bundle = deal; else delete props.__stack_bundle;
        body.properties = props;
      }
      return changeLine(body);
    });
    return chain.then(function () { return true; });
  }

  /* ---------------------------------------------------------------------
     Refresh the host theme's cart UI after we changed the cart (same event
     contract stack.js uses for Horizon 1.x–4.x), without popping the drawer.
     --------------------------------------------------------------------- */
  function refreshThemeCart(cart) {
    var count = cart && cart.item_count != null ? cart.item_count : null;
    var data = { items: (cart && cart.items) || [], itemCount: count, source: 'stack', didError: false };
    var restore = [];
    var auto = document.querySelectorAll('cart-drawer-component[auto-open]');
    for (var i = 0; i < auto.length; i++) { auto[i].removeAttribute('auto-open'); restore.push(auto[i]); }
    try {
      try {
        var evt = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
        evt.action = 'update';
        evt.context = 'product';
        evt.promise = Promise.resolve({ cart: count != null ? { totalQuantity: count } : null, detail: data });
        document.dispatchEvent(evt);
      } catch (e) { logErr('could not dispatch shopify:cart:lines-update', e); }
      if (document.querySelector('cart-icon, cart-drawer-component, cart-items-component')) {
        try {
          document.dispatchEvent(new CustomEvent('cart:update', {
            bubbles: true,
            detail: { resource: cart || null, sourceId: 'stack', data: data }
          }));
        } catch (e) { logErr('could not dispatch cart:update', e); }
      }
      try { document.dispatchEvent(new CustomEvent('stack:cart:update', { bubbles: true, detail: cart || {} })); } catch (e) {}
    } finally {
      for (var j = 0; j < restore.length; j++) {
        var node = restore[j];
        if (!document.contains(node)) node = document.querySelector('cart-drawer-component') || node;
        node.setAttribute('auto-open', '');
      }
    }
  }

  /* ---------------------------------------------------------------------
     Reconcile: one line per bundle product, tagged for its total quantity.
     --------------------------------------------------------------------- */
  var running = null;
  var rerun = false;

  function reconcile() {
    if (running) { rerun = true; return running; }
    running = getCart()
      .then(function (cart) {
        var totals = {};
        ((cart && cart.items) || []).forEach(function (l) {
          if (isUpsellLine(l)) return;
          var vid = String(l.variant_id);
          if (!TIERS[vid]) return;
          totals[vid] = (totals[vid] || 0) + l.quantity;
        });
        var chain = Promise.resolve(false);
        Object.keys(totals).forEach(function (vid) {
          chain = chain.then(function (changedSoFar) {
            var deal = dealFor(TIERS[vid], totals[vid]);
            return setVariantLine(cart, parseInt(vid, 10), totals[vid], deal).then(function (c) {
              if (c) log('reconciled variant ' + vid + ' → qty ' + totals[vid] + ', tag "' + deal + '"');
              return changedSoFar || c;
            });
          });
        });
        return chain;
      })
      .then(function (changed) {
        if (!changed) return null;
        return getCart().then(refreshThemeCart);
      })
      ['catch'](function (err) { logErr('reconcile failed', err); })
      .then(function () {
        running = null;
        if (rerun) { rerun = false; return reconcile(); }
      });
    return running;
  }

  /* ---------------------------------------------------------------------
     Watch the theme's own cart edits (drawer / cart page +/-, remove).
     --------------------------------------------------------------------- */
  var inflight = 0;
  var timer = null;

  function isCartMutation(url) {
    try { return CART_MUTATION.test(new URL(url, window.location.href).pathname); } catch (e) { return false; }
  }
  function schedule() {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () { timer = null; reconcile(); }, 300);
  }
  function mutationStart() { inflight++; }
  function mutationEnd() { inflight = Math.max(0, inflight - 1); schedule(); }
  function settled() { return !inflight && !timer && !running; }
  function whenSettled(maxMs) {
    var start = Date.now();
    return new Promise(function (resolve) {
      (function poll() {
        if (settled() || Date.now() - start > (maxMs || 6000)) return resolve();
        setTimeout(poll, 80);
      })();
    });
  }

  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var p = nativeFetch.apply(window, arguments);
      if (isCartMutation(url)) {
        mutationStart();
        p.then(mutationEnd, mutationEnd);
      }
      return p;
    };
  }

  if (window.XMLHttpRequest) {
    var xOpen = XMLHttpRequest.prototype.open;
    var xSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__stackCartMut = isCartMutation(url);
      return xOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (this.__stackCartMut) {
        var done = false;
        mutationStart();
        this.addEventListener('loadend', function () { if (!done) { done = true; mutationEnd(); } });
      }
      return xSend.apply(this, arguments);
    };
  }

  /* ---------------------------------------------------------------------
     Checkout guard: make sure the cart is reconciled before leaving.
     --------------------------------------------------------------------- */
  var leaving = false;
  function goToCheckoutSafely() {
    if (leaving) return;
    leaving = true;
    // Short pause lets a debounced theme quantity update start first.
    setTimeout(function () {
      whenSettled()
        .then(function () { return reconcile(); })
        .then(function () { return whenSettled(); })
        .then(function () { window.location.assign(root() + 'checkout'); });
    }, 250);
  }

  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest &&
      e.target.closest('button[name="checkout"], input[name="checkout"], a[href$="/checkout"], a[href*="/checkout?"]');
    if (!t) return;
    if (t.closest && t.closest(FORM_SELECTOR)) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goToCheckoutSafely();
  }, true);

  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || f.nodeName !== 'FORM' || (f.matches && f.matches(FORM_SELECTOR))) return;
    var sub = e.submitter;
    var toCheckout = (sub && sub.name === 'checkout') || /\/checkout/.test(f.getAttribute('action') || '');
    if (!toCheckout) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    goToCheckoutSafely();
  }, true);

  /* ---------------------------------------------------------------------
     Add to cart (main button + sticky bar) → replace line → checkout.
     --------------------------------------------------------------------- */
  function controllerFor(form) {
    var c = form.closest('stack-product');
    if (c) return c;
    var sticky = form.closest('stack-sticky-atc');
    return (sticky && sticky._host) || null;
  }

  function setBusy(form, busy) {
    form._stackBusy = busy;
    var buttons = form.querySelectorAll('[data-atc-button], [data-sticky-button]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].disabled = busy;
      buttons[i].setAttribute('aria-busy', busy ? 'true' : 'false');
      buttons[i].classList.toggle('is-loading', busy);
    }
  }

  var style = document.createElement('style');
  style.textContent =
    '.stack-atc__button.is-loading:disabled,.stack-sticky__button.is-loading:disabled{opacity:.85!important;cursor:progress!important;}';
  (document.head || document.documentElement).appendChild(style);

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.nodeName !== 'FORM' || !form.matches || !form.matches(FORM_SELECTOR)) return;

    var controller = controllerFor(form);
    if (controller && controller.getAttribute('data-direct-checkout') === 'false') return;

    var idInput = form.querySelector('input[name="id"]');
    if (!idInput || !idInput.value) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    if (form._stackBusy) return; // ignore double taps

    captureTiers();

    var variantId = parseInt(idInput.value, 10);
    var qtyInput = form.querySelector('input[name="quantity"]');
    var quantity = parseInt((qtyInput && qtyInput.value) || '1', 10) || 1;

    var map = TIERS[String(variantId)] || null;
    var deal = null;
    if (controller && controller._bundleDeal != null) deal = controller._bundleDeal || '';
    else if (map) deal = dealFor(map, quantity);

    var upsellItems = [];
    if (controller) {
      var upsells = controller.querySelectorAll('stack-upsell[data-mode="with_main"]');
      for (var i = 0; i < upsells.length; i++) {
        if (typeof upsells[i]._items === 'function') upsellItems = upsellItems.concat(upsells[i]._items());
      }
    }

    setBusy(form, true);

    var flow;
    if (deal !== null) {
      // Bundle product: the selected tier REPLACES whatever is in the cart.
      flow = getCart()
        .then(function (cart) { return setVariantLine(cart, variantId, quantity, deal); })
        .then(function () { return upsellItems.length ? addItems(upsellItems) : null; });
    } else {
      flow = addItems([{ id: variantId, quantity: quantity }].concat(upsellItems));
    }

    flow
      .then(function () { window.location.assign(root() + 'checkout'); })
      ['catch'](function (err) {
        logErr('add failed, falling back to normal submit', err);
        setBusy(form, false);
        form.submit(); // native POST — does not re-fire this listener
      });
  }, true);

  /* ---------------------------------------------------------------------
     Boot: learn tiers, fix any stale cart, handle back-button restores.
     --------------------------------------------------------------------- */
  function boot() {
    captureTiers();
    reconcile();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    leaving = false;
    var forms = document.querySelectorAll(FORM_SELECTOR);
    for (var i = 0; i < forms.length; i++) {
      if (forms[i]._stackBusy) setBusy(forms[i], false);
    }
    reconcile();
  });

  // Exposed for debugging only.
  window.__StackBundleSafe = { reconcile: reconcile, tiers: function () { return TIERS; }, dealFor: dealFor };
})();
